import React from "react";
import "./Home.css";  // make sure to import the same CSS with dark/light rules

const ContactUs = () => {
  return (
    <div className="contact-us-wrapper">
      <div className="contact-us-container">
        <h1 className="contact-heading">Contact Us</h1>

        <p className="contact-text">
          Have a project in mind or want to learn more about our services? We'd love to hear from you.
          Please use the contact details below to reach out. We're committed to providing prompt and
          professional responses.
        </p>

        <div className="contact-details">
          <p><strong>👨‍💻 Name:</strong> Jitendra Patil</p>
          <p><strong>🏢 Company:</strong> Adnya Technologies</p>
          <p><strong>📍 Location:</strong> Thane, Maharashtra, India</p>
          <p><strong>📞 Phone:</strong> +91-9960059223</p>
          <p><strong>✉️ Email:</strong> jitu2patil@gmail.com</p>
          <p>
            <strong>🌐 Website:</strong>{" "}
            <a href="https://adnyatech.com" target="_blank" rel="noopener noreferrer" className="contact-link">
              www.adnyatech.com
            </a>
          </p>
        </div>

        <p className="contact-text">
          We're always excited to collaborate on new ideas, support innovations, and solve real-world
          business problems with practical software solutions.
        </p>
      </div>
    </div>
  );
};

export default ContactUs;
